import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { PendingChecklistsQueryKeys } from "modules/PendingChecklistsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { InterventionKeywordPendingChecklist } from "models";

export const useDeleteInterventionPendingChecklistMutation = () =>
  useTypedMutation<InterventionKeywordPendingChecklist, void>({
    mutationFn: async payload => (await ApiInstance.post("/intervention_keywords_pending_checklists/delete", payload, ENV.dealerBaseURL)).data,
    onSuccess: ({ checklist_id, keyword, vin_prefix }) => {
      const pendingChecklists = typedQueryClient.getQueryData(PendingChecklistsQueryKeys.interventionPendingChecklists);
      if (!pendingChecklists?.length) return;

      const pendingChecklistIdx = pendingChecklists.findIndex(p => p.checklist_id === checklist_id && p.keyword === keyword && p.vin_prefix === vin_prefix);
      if (pendingChecklistIdx === -1) return;

      typedQueryClient.setQueryData(PendingChecklistsQueryKeys.interventionPendingChecklists, pendingChecklists.toSpliced(pendingChecklistIdx, 1));
    }
  });
